// extracted by mini-css-extract-plugin
export var alertIcon = "_si-0";